module.exports = __webpack_public_path__ + "static/embargo-logo-7bb2d837cb7c6eeda23e26b0307a9a13.png";